export const clientFr = {
  "Dette": "Dette",
  "Creance": "Creance",
  "Nom...": "Nom...",
  "Telephone...": "Telephone...",
  "Chercher un Client": "Chercher un Client",
  "Choisir un client": "Choisir un client",
  "Information du client": "Information du client",

  "Historique de paiements": "Historique de paiements",

}